import { render, staticRenderFns } from "./Registry.vue?vue&type=template&id=cdceb016&scoped=true"
import script from "./Registry.vue?vue&type=script&lang=js"
export * from "./Registry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdceb016",
  null
  
)

export default component.exports